var map = {
	"./弹窗-固废.png": "danE",
	"./弹窗-大气.png": "Yv9g",
	"./弹窗-水质.png": "q8kX",
	"./弹窗-污染源.png": "fHko"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JUP/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp ^\.\/弹窗\-.*\.png$
// module id = JUP/
// module chunks = 3